import { titleCase as generalTitleCase } from '../../../../../utils/general'

export const titleCaseFormatter = (value: string): string => {
  return generalTitleCase(value)
}

export const valueLabelFormatter = (params: { value: string }): string => {
  return titleCaseFormatter(params.value)
}
